module.exports = __webpack_public_path__ + "media/fonts/Cormorant-Medium-05a9142b4c965a2b4155c998122e27cb.woff";